<template>
    <transition name="fade">

        <div id="overlay" @click="closeGallery" >

            <div id="gallery" class="overlay-content gallery-size" onclick="event.stopPropagation();">

    			<img v-for="image in images" alt="" :src="image"
    				:data-image="image">

    		</div>
            <!--</div>-->
        </div>
    </transition>

</template>

<script>
export default{
    props:['images'],
    data:function () {
        return {
            galleryApi : {},
        };
    },
    mounted:function () {
        var self = this;
        self.galleryApi = $("#gallery")
            .unitegallery({
                slider_scale_mode: "fit"
            });
        // this.$nextTick(function () {
        //
        // })

    },
    methods:{
        closeGallery:function () {
            this.$emit('closeGallery');
        }
    }
}
</script>

<style>
    #overlay {
        position: fixed; /* Sit on top of the page content */
        display: block;
        width: 100%; /* Full width (cover the whole page) */
        height: 100%; /* Full height (cover the whole page) */
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(0, 0, 0, 0.8); /* Black background with opacity */
        z-index: 999999; /* Specify a stack order in case you're using a different order for other elements */
        cursor: pointer; /* Add a pointer on hover */
    }

    .overlay-content {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        -ms-transform: translate(-50%, -50%);
    }
    .gallery-size {
        width: 100%;
        height: 100%;
        max-height: 600px;
        max-width: 800px!important;
        min-width: 800px!important;
    }
    .fade-enter-active, .fade-leave-active {
        transition: opacity .5s
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
        opacity: 0
    }
</style>



// WEBPACK FOOTER //
// Gallery.vue?cd2dfcfe